//--
import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const ShotCancellationAdd = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.ItemAcceptanceCancellationCommandURL.ShotCancellationAdd,
        method: RequestType.POST,
        data,
    });

const ProductAcceptanceAdd = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.ItemAcceptanceCancellationCommandURL.ProductAcceptanceAdd,
        method: RequestType.POST,
        data,
    });

const UploadImage = (formData: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.ItemAcceptanceCancellationCommandURL.UploadImage,
        method: RequestType.POST,
        data: formData,
        requestType: 'FromForm',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });

export const ItemAcceptanceCancellationCommand = {
    ShotCancellationAdd,
    ProductAcceptanceAdd,
    UploadImage,
};
